import { FilterEntry } from 'mbs-ui-shared@components/sidepanel-rmm/event-total-tab/event-total-tab.model';
import EventLogInfo, { EventLogTypesEnum, IEventLogEntry } from 'mbs-ui-shared@models/rmm/EventLogInfo';

export const ActionPrefix = '[EventTotal/API]';

export interface EventEntry extends IEventLogEntry {
  id?: number;
  level?: string;
  cssClass?: string;
  time?: Date | string;
  timeUTC?: Date;
  source: string;
  logType: EventLogTypesEnum;
  icon?: string;
  order?: number;
}

export interface EventChart extends EventLogInfo {
  id: any;
}

export type EventEntryFilter = FilterEntry;

export const EventEntryLimit = 500;
